import CalendarEventsFilterInfo from "../../../context/calendarEventsFilterInfo";

export const buildFilterInfo = (filter: any) => {
    if (!filter) {
        return new CalendarEventsFilterInfo();
    }
    if (filter instanceof CalendarEventsFilterInfo) {
        return filter;
    }

    return CalendarEventsFilterInfo.fromApiObject(filter);
};

export const filterCount = (filterInfo: CalendarEventsFilterInfo | null): number => {
    if (!filterInfo) {
        return 0;
    }

    filterInfo = buildFilterInfo(filterInfo);

    let count = 0;

    if (filterInfo.searchText && filterInfo.searchText.trim() !== "") {
        count++;
    }

    if (filterInfo.calendarEventResources && filterInfo.calendarEventResources.length > 0) {
        count += filterInfo.calendarEventResources.length;
    }

    if (filterInfo.statuses && filterInfo.statuses.length > 0) {
        count += filterInfo.statuses.length;
    }

    return count;
};
